import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/lib/auth/store';

/**
 * Redirects unauthenticated users to /login while preserving the intended
 * destination as ?from=… so we can bounce back after a successful login.
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const isAuthed = useAuthStore((s) => s.isAuthenticated());
  const location = useLocation();

  if (!isAuthed) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}

/** Inverse — bounces authed users away from /login. */
export function RedirectIfAuthed({ children }: { children: React.ReactNode }) {
  const isAuthed = useAuthStore((s) => s.isAuthenticated());
  if (isAuthed) return <Navigate to="/" replace />;
  return <>{children}</>;
}
